import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id A5F7D4AF-C7A3-4F38-B21B-B9F3E68770DE
 * name checkerboard
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/checkerboard.svg
 * tags
 * - Gaming / RPG 
 * - Geographic Information System 
 */
export const CheckerboardIcon = createSvgIcon(<><path d="M2 2V22H22V2H2M20 12H16V16H20V20H16V16H12V20H8V16H4V12H8V8H4V4H8V8H12V4H16V8H20V12M16 8V12H12V8H16M12 12V16H8V12H12Z" /></>, 'CheckerboardIcon');
export default CheckerboardIcon